import React, { useEffect, useState, useRef } from "react";
import { Typography } from "@material-ui/core";
import useStyles from "../../styles/adminUtilityStyle";
import { url } from "../../apis/apiSetup";
import { useTranslation } from "../../langs/useTranslation";
import HOCforFullWidthTable from "../../hoc/FullWidthTableWrapper";
import "../../css/dataTable.css";
import * as localforage from "localforage";
import * as $ from "jquery";
import "datatables.net";
import "datatables.net-autofill";
import "datatables.net-buttons";
import "datatables.net-fixedcolumns";
import "datatables.net-fixedheader";
import "datatables.net-keytable";
import "datatables.net-rowreorder";
import "datatables.net-scroller";
import "datatables.net-searchpanes";
import {
  AddBoxRounded,
  AutorenewRounded,
  DeleteRounded,
  EditRounded
} from "@material-ui/icons";
import AddOrEditFWUtilityDialog from "./AddOrEditFWUtilityDialog";
import { searchStyleRender } from "../../helpers/datatableSearchStyleRender";
import RemoveFWUtilityDialog from "./RemoveFWUtilityDialog";
import DeviceOwners from "../commons/DeviceOwners";
import { language } from "../../helpers/datatableLanguage";
import { ReactRender } from "../ReactRender";
import { errorHandling } from "@/helpers/errorHandling";

const FWUtilityList = () => {
  const mounted = useRef();
  const classes = useStyles();
  const { t } = useTranslation("adminUtility");
  const [editDialigOpen, setEditDialogOpen] = useState(false);
  const [removeDialigOpen, setRemoveDialogOpen] = useState(false);
  const [fwData, setFwData] = useState();

  const handleReloadDataTable = () => {
    table();
  };

  const table = async () => {
    const token = await localforage.getItem("token");
    $("#fw-utility-table").DataTable({
      processing: true,
      serverSide: true,
      language: language(t),
      searching: true,
      filter: false,
      deferRender: true,
      info: true,
      autoWidth: false,
      stateSave: false,
      destroy: true,
      pageLength: 15,
      ordering: false,
      ajax: {
        url: `${url}/api/v2/admin-utility/firmware/dataTable`,
        type: "GET",
        dataSrc: "data",
        beforeSend: request => {
          request.setRequestHeader("Authorization", "Bearer " + token);
          request.setRequestHeader("Accept", "application/json");
        },
        error: err => {
          errorHandling(err);
        }
      },
      columns: [
        {
          data: "peripheral_type",
          title: `${t("table.peripheralType")}`,
          name: "peripheralType.name",
          searchable: true,
          render: data => {
            return data.name;
          }
        },
        {
          data: "name",
          title: `${t("table.utility")}`,
          searchable: true,
          render: data => {
            return data ? data : "-";
          }
        },
        {
          data: "firmware_company_model_maps",
          title: `${t("table.modelName")}`,
          name: "firmwareCompanyModelMaps.deviceModel.name",
          searchable: true,
          render: data => {
            const modelNames = data
              .map(o => {
                return o.device_model ? o.device_model.name : "";
              })
              .filter(o => o);
            const uniqueModelNames = [...new Set(modelNames)];
            return uniqueModelNames.length > 0
              ? uniqueModelNames.join(", ")
              : "-";
          }
        },
        {
          data: "firmware_company_model_maps",
          name: "firmwareCompanyModelMaps.company.name",
          title: `${t("table.company")}`,
          searchable: true,
          createdCell: (td, data) => {
            let companyNames = data
              .map(o => {
                return o.company ? o.company.name : "";
              })
              .filter(o => o);
            const uniqueCompanyNames = [...new Set(companyNames)];
            ReactRender(<DeviceOwners owners={uniqueCompanyNames} />, td);
          }
        },
        { data: "note", title: `${t("table.note")}`, searchable: false },
        {
          data: "peripheral_type_id",
          title: `${t("table.action")}`,
          searchable: false,
          className: "action",
          createdCell: (td, data, rowData) => {
            ReactRender(
              <>
                <EditRounded onClick={() => handleEditDialogOpen(rowData)} />
                <DeleteRounded
                  onClick={() => handleRemoveDialogOpen(rowData)}
                />
              </>,
              td
            );
          }
        }
      ]
    });
    searchStyleRender();
  };

  const handleEditDialogOpen = data => {
    setFwData(data);
    setEditDialogOpen(true);
  };

  const handleCreateDialogOpen = () => {
    setFwData();
    setEditDialogOpen(true);
  };

  const handleEditDialogClose = () => {
    setEditDialogOpen(false);
    table();
  };

  const handleRemoveDialogOpen = data => {
    setFwData(data);
    setRemoveDialogOpen(true);
  };

  const handleRemoveDialogClose = data => {
    setFwData(data);
    setRemoveDialogOpen(false);
    table();
  };

  useEffect(() => {
    if (!mounted.current) {
      table();
      mounted.current = true;
    }
  });

  return (
    <div>
      <Typography variant="h5" className={classes.tableTitle}>
        {t("table.fwUtilityTitle")}
        <AutorenewRounded
          onClick={handleReloadDataTable}
          size="small"
          className={classes.reload_btn}
        />
        <AddBoxRounded
          onClick={handleCreateDialogOpen}
          size="small"
          className={classes.listBtn}
        />
      </Typography>
      <HOCforFullWidthTable>
        <table
          id="fw-utility-table"
          className="mdl-data-table dataTable no-footer dtr-inline"
        >
          <thead>
            <tr>
              <th>{t("table.peripheralType")}</th>
              <th>{t("table.utility")}</th>
              <th>{t("table.modelName")}</th>
              <th>{t("table.company")}</th>
              <th>{t("table.note")}</th>
              <th>{t("table.action")}</th>
            </tr>
          </thead>
        </table>
      </HOCforFullWidthTable>
      <RemoveFWUtilityDialog
        open={removeDialigOpen}
        fwData={fwData}
        onClose={handleRemoveDialogClose}
      />
      <AddOrEditFWUtilityDialog
        open={editDialigOpen}
        fwData={fwData}
        onClose={handleEditDialogClose}
      />
    </div>
  );
};

export default FWUtilityList;
